module.exports = __webpack_public_path__ + "static/contentselection-backgroundregion-dont-49965d76b34498c22bf8d9875fcb1e0b.png";